import React, {FC} from "react"
import {H3, H4, H6, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import {UserSavingsBrand} from "@irati/types"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import PropTypes from "prop-types"
import mySavingsTracking from "@irati-tracking/my-savings/mySavings"
import {BrandLogoUrl, TopBrandsWrapper} from "./styles"

interface Props {
  brands?: UserSavingsBrand[]
  currency: string
}

const MyFavouriteBrands: FC<Props> = ({brands, currency}, {apps}) => {
  if (!brands?.length) return null
  if (brands?.length === 1 && brands[0].brandId === "no-brand") return null
  const theme = useTheme()

  const topThreeBrands = brands
    .sort((a, b) => b?.totalRedemptions - a?.totalRedemptions)
    .filter((brand) => brand.brandId !== "no-brand")
    .slice(0, 3)

  const handleClickBrand = () => {
    mySavingsTracking.clickBrand("my_savings", "perks", "top_brands")
  }

  return (
    <TopBrandsWrapper>
      <Flex direction="column" gap={3}>
        <H4>
          <FormattedMessage id="savings.topBrands.title" values={{count: topThreeBrands.length}} />
        </H4>

        {topThreeBrands.map((b) => (
          <Flex key={b.brandId} gap={1} flex="1">
            <BrandLogoUrl logoUrl={b.brandLogoUrl} />
            <Flex direction="column">
              <Flex alignItems="center" gap={0.5} wrap="wrap">
                <H3>
                  <FormattedCurrency value={b?.totalSavings} currency={currency} isCents={false} />
                </H3>
                <Label>
                  <FormattedMessage id="savings.topBrands.inSavingsWith" />
                </Label>
                {b.brandSlug ? (
                  <H6>
                    <ButtonRouterLink to={`/brands/${b?.brandSlug}`} app={apps.PERKS} cta tertiary onClick={handleClickBrand}>
                      {b.brandName}
                    </ButtonRouterLink>
                  </H6>
                ) : (
                  <H6> {b.brandName}</H6>
                )}
              </Flex>
              <Label color={theme.colors.greys.mediumDark}>{b.totalRedemptions} redemptions</Label>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </TopBrandsWrapper>
  )
}

MyFavouriteBrands.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default MyFavouriteBrands
